




















import Vue from 'vue';
import { chain, omitBy } from 'lodash';

import { ModalSize } from '@/components/zen_modal/types';
import { createNewJiraIssue } from '@/utils/crudActions';
import { includeField } from './helpers';
import Issue from './components/Issue.vue';

export default Vue.extend({
  name: 'NewJiraIssue',
  components: {
    Issue,
  },
  props: {
    fields: {
      type: Object,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
    issueTypeId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      issue: {
        fields: chain(this.fields)
          .omitBy(field => includeField(field, ['components']))
          .mapValues(() => null)
          .merge({
            project: { id: this.projectId },
            issuetype: { id: this.issueTypeId },
          })
          .value(),
      },
      isSaving: false,
    };
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Large });
  },
  methods: {
    async save() {
      this.isSaving = true;

      const fields = omitBy(this.issue.fields, field => field === null);

      try {
        await this.createNewJiraIssue({
          csrf: this.csrfToken,
          fields,
          objectId: String(this.objectId),
          objectType: this.objectType,
        });
        window.GGRC.zenModal.$emit('reloadPage');
        window.GGRC.zenModal.hideAll();
      } catch (error) {
        window.GGRC.Notify({ type: 'error', message: error });
      } finally {
        this.isSaving = false;
      }
    },
    createNewJiraIssue,
  },
});
